// validators/activity.js
import { sharedValidators } from "./shared";

const activityValidators = {
  3: ({ step1 }, t) =>
    !step1.activity_type_id ? t("please_select_type") : null,

  6: ({ step1 }, t) =>
    step1.has_guide &&
    step1.guide_in_person.length === 0 &&
    step1.guide_audio.length === 0 &&
    step1.guide_information.length === 0
      ? t("please_select_guide")
      : null,

  9: ({ step2 }, t) =>
    step2.is_transport_used && step2.transport_type_id == null
      ? t("please_select_transport_type")
      : null,

  11: ({ step2 }, t) => {
  if (!step2.included_items || step2.included_items.filter(i => i?.trim()).length === 0)
    return t("please_fill_included_items");

  if (!step2.excluded_items || step2.excluded_items.filter(i => i?.trim()).length === 0)
    return t("please_fill_excluded_items");

  return null;
},

  13: ({ step3 }, t) => {
    if (!step3.min_duration_value || !step3.max_duration_value)
      return t("please_fill_duration");
    if (!step3.arrival_time_value) return t("please_fill_arrival_time");
    if (!step3.cutoff_time_booking_value) return t("please_fill_cutoff_time");

    if (
      !step3.schedules ||
      step3.schedules.length === 0 ||
      step3.schedules.some(({ day, start_time, end_time }) => {
        if (day && (!start_time?.trim() || !end_time?.trim())) return true;
        if (start_time && end_time && start_time >= end_time) return true;
        return false;
      })
    )
      return t("please_fill_schedule");

    if (!step3.meeting_point?.trim()) return t("please_fill_meeting_point");
    if (step3.has_dropoff_location && !step3.dropoff_location?.trim())
      return t("please_fill_dropoff_location");

    return null;
  },

  shared: [
    sharedValidators.title,
    sharedValidators.location,
    sharedValidators.summary,
    sharedValidators.description,
    sharedValidators.keyPoints,
    sharedValidators.keywords,
    sharedValidators.images,
    // sharedValidators.cutoffTime,
    sharedValidators.dateRange,
    sharedValidators.cancellationPolicy,
    sharedValidators.bookingConfirmation,
    sharedValidators.applicableDays,
  ],
};

export default activityValidators;
